import type { ResponseArray } from './response'

export interface IParamsOptions {
  headers?: Record<string, string>
  params?: Record<string, any>
  data?: Record<string, any>
  method?: HTTPMethod
  cache?: boolean
}

export interface IHTTPCreateOptions extends IParamsOptions {
  url: string
}

export interface IHTTP<T> {
  with(paramOptions: IHTTPCreateOptions): IHTTP<T>
  withParams(params: Record<string, any>): IHTTP<T>
  withData(data: Record<string, any>): IHTTP<T>
  config(config: RequestInit): IHTTP<T>
  get(params?: IParamsOptions): IHTTP<T>
  post(params?: IParamsOptions): IHTTP<T>
  put(params?: IParamsOptions): IHTTP<T>
  delete(params?: IParamsOptions): IHTTP<T>
  json(): Promise<T>
  array(): Promise<ResponseArray<T>>
  abort(): IHTTP<T>
}

export enum HTTPMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  PATCH = 'PATCH',
}

export interface HTTPResponseArray<T> {
  data: T[]
  total: number
}

export type HTTPResponseRecord<T> = {
  [prop in keyof T]: T[prop]
}

export interface IFetcher<T> {
  (): Promise<T>
}

export interface ICustomArrayResponse<T> {
  (data: Response): ResponseArray<T>
}
